import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Layout, Menu, Dropdown, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { get_permissable_routes } from "../../routing/appRouter";
import { siteConfig } from "../../settings/config";
import { TopbarUser, TopbarSalutation } from "./topbar";
import TopbarWrapper from "./topbar.style";
import LanguageToggle from "../languageToggle";

import { FormattedMessage } from "react-intl";
import { withTheme } from "styled-components";
import Settings from "../../modules/settings";

import AppContext from "../../AppContext";

const { Header } = Layout;

class Topbar extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      viewSettings: false,
    };
  }

  getSelectedKeys = paths => {
    let selected = [];

    paths.forEach(r => {
      if (r.children) {
        r.children.forEach(c => {
          let path = `/${c.product}/${c.regex ? c.regex : c.path}`;

          if (path === this.props.match.path) {
            selected.push(c.key);
          }
        });
      } else {
        let path = `/${r.product}/${r.regex ? r.regex : r.path}`;

        if (path === this.props.match.path) {
          selected.push(r.key);
        }
      }
    });

    return selected;
  };

  getMenuItem = ({ singleOption, submenuStyle, submenuColor }) => {
    const { key, path, label, leftIcon, product, onMenu, children } = singleOption;
    if (onMenu) {
      let url = "/" + product;
      if (children) {
        return (
          <Menu.SubMenu
            key={key}
            title={
              <span className="isoMenuHolder" style={submenuColor}>
                {leftIcon !== undefined ? leftIcon : false}
                &nbsp;
                <span className="nav-text text-capitalize">
                  <FormattedMessage id={label} />
                </span>
              </span>
            }
          >
            {children.map(child => {
              if (child.onMenu) {
                let curl = child.product;
                const linkTo = child.withoutDashboard ? `/${child.path}` : `/${curl}/${child.path}`;

                return (
                  <Menu.Item style={submenuStyle} key={child.key}>
                    <Link style={submenuColor} to={linkTo}>
                      <span className="nav-text text-capitalize">
                        <FormattedMessage id={child.label} />
                      </span>
                    </Link>
                  </Menu.Item>
                );
              } else {
                return false;
              }
            })}
          </Menu.SubMenu>
        );
      }
      return (
        <Menu.Item key={key}>
          <Link to={`${url}/${path}`}>
            <span className="isoMenuHolder" style={submenuColor}>
              {leftIcon !== undefined ? leftIcon : false}
              &nbsp;
              <span className="nav-text text-capitalize">
                <FormattedMessage id={label} />
              </span>
            </span>
          </Link>
        </Menu.Item>
      );
    } else {
      return false;
    }
  };

  render() {
    const options = get_permissable_routes(
      this.context.permissions[this.context.active_role],
      this.context.features
    );
    const selected = this.getSelectedKeys(options);
    const collapsed = window.innerWidth <= 1024;
    return (
      <TopbarWrapper>
        <Header id="topbar-container" className={`topbarHeaderBar ${collapsed && "collapsedMenuPadding"}`}>
          <div className="topbarContentLeft">
            <div className="topbarLogo" onClick={() => this.context.navigate("/")}>
              <img src={siteConfig[this.props.theme.topmenuLogo]} alt="" />
            </div>
          </div>
          <div className="topbarContentRight">
            {collapsed ? (
              <>
                <LanguageToggle />
                <TopbarUser showSettings={() => this.setState({ viewSettings: true })} />
                <Dropdown
                  trigger={["click"]}
                  arrow
                  overlay={
                    <Menu
                      theme={this.props.theme.topmenuTheme}
                      className="topbarMenuContent"
                      defaultOpenKeys={[]}
                      selectedKeys={selected}
                      onSelect={this.context.updateTotalNotifications}
                    >
                      {options.map(singleOption => this.getMenuItem({ singleOption: singleOption }))}
                    </Menu>
                  }
                >
                  <Button className="topbarDropdownMenu" type="text" style={{ padding: 0 }}>
                    <MenuOutlined className="collapseSidebarToggle" />
                  </Button>
                </Dropdown>
              </>
            ) : (
              <>
                <Menu
                  theme={this.props.theme.topmenuTheme}
                  className="topbarMenuContent"
                  mode={"horizontal"}
                  defaultOpenKeys={[]}
                  selectedKeys={selected}
                >
                  {options.map(singleOption => this.getMenuItem({ singleOption: singleOption }))}
                </Menu>
                <LanguageToggle />
                <TopbarUser showSettings={() => this.setState({ viewSettings: true })} />
              </>
            )}
            <Settings visible={this.state.viewSettings} closeSettings={() => this.setState({ viewSettings: false })} />
          </div>
        </Header>
        <TopbarSalutation />
      </TopbarWrapper>
    );
  }
}

export default withRouter(withTheme(Topbar));
